export default __webpack_public_path__ + "static/media/Cover-Image.a73f890d.png";